module.exports = __webpack_public_path__ + "img/slide_notice_sto.df3967cf.svg";